import { camelCase } from '../util.js'
const works = [
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-vive-0'),
    zpic: [
      camelCase('cases-brand-vive-lazyload-01')
    ]
  },
  {
    title: '奢享新颜 挚爱礼遇',
    desc: '奢享新颜 挚爱礼遇',
    thumb: camelCase('cases-brand-vive-1'),
    zpic: [
      camelCase('cases-brand-vive-lazyload-11')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-vive-2'),
    zpic: [
      camelCase('cases-brand-vive-lazyload-21')
    ]
  },
  {
    title: '凝香奢养 留驻玉容芳华',
    desc: '凝香奢养 留驻玉容芳华',
    thumb: camelCase('cases-brand-vive-3'),
    zpic: [
      camelCase('cases-brand-vive-lazyload-31')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-vive-4'),
    zpic: [
      camelCase('cases-brand-vive-lazyload-41')
    ]
  },
  {
    title: 'VIVE',
    desc: 'VIVE',
    thumb: camelCase('cases-brand-vive-5'),
    zpic: [
      camelCase('cases-brand-vive-lazyload-51')
    ]
  },
  {
    title: '香颂时光 初遇致美',
    desc: '香颂时光 初遇致美',
    thumb: camelCase('cases-brand-vive-6'),
    zpic: [
      camelCase('cases-brand-vive-lazyload-61')
    ]
  },
  {
    title: '美自东方 醉国潮',
    desc: '美自东方 醉国潮',
    thumb: camelCase('cases-brand-vive-7'),
    zpic: [
      camelCase('cases-brand-vive-lazyload-71')
    ]
  },
  {
    title: '新禧之夜 礼享惊喜',
    desc: '新禧之夜 礼享惊喜',
    thumb: camelCase('cases-brand-vive-8'),
    zpic: [
      camelCase('cases-brand-vive-lazyload-81')
    ]
  }
]
export default {
  name: '双妹',
  logo: {
    default: camelCase('cases-brand-16'),
    active: camelCase('cases-brand-16-cover')
  },
  works
}
